<template>
  <div>
    <md-progress-bar md-mode="query" class="md-accent" v-if="loadingTicket"></md-progress-bar>
    <div class="container md-layout" v-else>
      <div class="md-layout-item md-size-60">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
              <md-icon>local_activity</md-icon>
            </div>
            <h4 class="title">{{ $t("ticket.detail.title") }}</h4>
          </md-card-header>
          <md-card-content>
            <md-list>
              <md-list-item>
                <span>
                  <strong>Descripción : </strong> {{ticket.description}}
                </span>
              </md-list-item>
              <md-list-item>
                <span>
                  <strong>Equipo : </strong> {{ticket.team}}
                </span>
              </md-list-item>
              <md-list-item>
                <span>
                  <strong>Fecha de caducidad : </strong> {{formatDate(ticket.dueDate)}}
                </span>
              </md-list-item>
              <md-list-item>
                <span>
                  <strong>Cantidad Total : </strong> {{ticket.size}} | <i>Utilizados : {{ticket.used}}</i>
                </span>
              </md-list-item>
              <md-list-item>
                <span>
                  <strong>Creado por : </strong> {{ticket.createUser}} ( <i>{{formatDate(ticket.createDate)}}</i> )
                </span>
              </md-list-item>
              <md-list-item>
                <span>
                  <strong>Solo para un juego : </strong> {{ticket.onlyOneGame ? 'Si': 'No'}}
                </span>
              </md-list-item>
            </md-list>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-40">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
              <md-icon>local_activity</md-icon>
            </div>
            <h4 class="title">{{ $t("ticket.detail.actions") }}</h4>
          </md-card-header>
          <md-card-content>
            <md-button class="md-simple" @click="downloadTicketera()">
              <md-icon>file_copy</md-icon>
              {{ $t("ticket.detail.download") }}
            </md-button>
            <md-button class="md-simple md-danger" @click="modalDelete = true">
              <md-icon>delete</md-icon>
              {{ $t("ticket.detail.delete") }}
            </md-button>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <!-- Modal Delete -->
    <modal v-if="modalDelete" @close="modalDelete = false">
      <template slot="header">
        <h4 class="modal-title">¿ Desea eliminar la ticketera ?</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modalDelete = false">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <md-checkbox v-model="deleteAssigned">
          Eliminar entradas ya asignadas
        </md-checkbox>
      </template>

      <template slot="footer">
        <md-button class="md-simple md-danger" @click="deleteLoading()" :disabled="deleteLoading">Eliminar</md-button>
      </template>
    </modal>

  </div>
</template>

<script>
import moment from 'moment'
import { Modal } from '@/components'

export default {
  components: {
    Modal
  },
  data() {
    return {
      loadingTicket: true,
      ticket: {},
      modalDelete: false,
      deleteLoading: false,
      deleteAssigned: false
    }
  },
  async mounted() {
    const request = await this.$store.dispatch("subscriptionLotGetById", {
      id: this.$route.params.id
    })
    this.ticket = request.data
    this.loadingTicket = false
  },
  methods: {
    downloadTicketera() {
      const a = document.createElement("a")
      a.href = `${process.env.VUE_APP_CDN_URL_FAN_TICKET_CSV}${this.ticket.fileName}`
      a.setAttribute("download", "download")
      a.id = 'zipTickets'
      document.body.appendChild(a);
      a.click();
      document.getElementById('zipTickets').remove();
    },
    formatDate(date) {
      if (date == null) return
      return moment(date).format("DD/MM/YYYY HH:mm")
    },
    async deleteTicketera() {
      this.deleteLoading = true 
      await this.$store.dispatch('subscriptionLotDelete', {
        lotId: this.$route.params.id,
        deleteAssigned: this.deleteAssigned
      })
      this.$notify({
        message: this.$t(`notifications.ticket.delete`),
        icon: 'add_alert',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: 'success'
      })
      this.deleteLoading = false
      this.$router.push(`/list/ticketera`)
    }
  }
}
</script>